"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconSocialMusicSpotify1 = /*#__PURE__*/
function (_Icon) {
  _inherits(IconSocialMusicSpotify1, _Icon);
  function IconSocialMusicSpotify1(props) {
    var _this;
    _classCallCheck(this, IconSocialMusicSpotify1);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconSocialMusicSpotify1).call(this, props));
    _this.name = 'IconSocialMusicSpotify1';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("path", {
      className: "social-music-spotify-1_svg__path0",
      d: "M12 0a12 12 0 1012 12A12 12 0 0012 0zm5.38 17.72a.75.75 0 01-1.06.07 9.59 9.59 0 00-4.89-2 9.64 9.64 0 00-5.24.6.75.75 0 01-.63-1.39 11 11 0 016.08-.73 11 11 0 015.67 2.4.75.75 0 01.07 1.05zm.55-4a.75.75 0 01-1.06.07 9.59 9.59 0 00-4.88-2 9.57 9.57 0 00-5.26.61.75.75 0 11-.64-1.4 10.94 10.94 0 016.11-.74 11 11 0 015.66 2.39.75.75 0 01.07 1.1zm.64-3.91a.75.75 0 01-1.06.05 9.49 9.49 0 00-5-2.1 9.54 9.54 0 00-5.33.65.75.75 0 11-.66-1.35 11 11 0 016.2-.78 11 11 0 015.75 2.48.75.75 0 01.1 1.08z"
    }));
    return _this;
  }
  return IconSocialMusicSpotify1;
}(_Icon3.default);
exports.default = IconSocialMusicSpotify1;